// import { pathOr } from 'ramda'

// import useProgram from '../stores/use-program'
import Slider from './slider'

// const titleSelector = pathOr('', ['program', 'title'])
// const coverSelector = pathOr({ image: '', video: '' }, ['program', 'cover'])

const Cover = () => {
  // const title = useProgram(titleSelector)
  // const { image } = useProgram(coverSelector)

  return (
    <div className='lg:col-span-4 lg:row-end-1'>
      <Slider />
      {/* <div className='aspect-w-4 aspect-h-3 overflow-hidden rounded-4xl bg-gray-100'> */}
      {/* <img src={image} alt={title} className='object-contain object-bottom' /> */}
      {/* </div> */}
    </div>
  )
}

export default Cover
